import {
  ConnectionStatusBadge,
  DashboardSectionAction,
  Card,
  CardContent,
  navigateWithThreadPreservation,
  cn,
} from '@yeshuman/sdk'
import type { StreamingSseStatus } from '@yeshuman/sdk'
import { PhoneCall } from 'lucide-react'
import { useNavigate, useSearchParams } from 'react-router-dom'


export type CallLivePulseStripProps = {
  activeCount: number
  sseStatus: StreamingSseStatus
  lastEventAt: number | null
  loading?: boolean
  className?: string
}

export function CallLivePulseStrip({
  activeCount,
  sseStatus,
  lastEventAt,
  loading = false,
  className,
}: CallLivePulseStripProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isLive = sseStatus === 'open'

  return (
    <Card
      className={cn(
        'border-primary/25 bg-primary/5 shadow-sm overflow-hidden',
        className
      )}
    >
      <CardContent className="flex flex-col gap-4 py-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-4 min-w-0">
          <div className="min-w-0">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Active calls
            </p>
            <div className="flex items-baseline gap-2 mt-0.5">
              <span
                className={cn(
                  'text-3xl font-bold tabular-nums tracking-tight text-foreground',
                  isLive && activeCount > 0 && 'animate-pulse'
                )}
              >
                {loading ? '…' : activeCount}
              </span>
              {isLive ? (
                <span className="text-xs text-success font-medium">Live feed</span>
              ) : null}
            </div>
          </div>
          <ConnectionStatusBadge status={sseStatus} lastEventAt={lastEventAt} />
        </div>
        <DashboardSectionAction
          onClick={() =>
            navigateWithThreadPreservation(navigate, '/calls/records', searchParams)
          }
        >
          <PhoneCall className="size-4" aria-hidden />
          Open live board
        </DashboardSectionAction>
      </CardContent>
    </Card>
  )
}
